import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import 'react-date-picker/dist/DatePicker.css';
// import 'react-calendar/dist/Calendar.css';
import './indexStyles.css';
import {
   FONT_FAMILY_REGULAR,
   base100,
   primaryColor900a,
} from '../../utils/utils';
import {TextInput} from 'react-native';

const CustomDateTimePicker = props => {
   const customInput = <TextInput />;
   return (
      <DatePicker
         testID="dateTimePicker"
         selected={props.selectedDate}
         maxDate={props.maximumDate}
         popperPlacement="top"
         onChange={date => {
            props.setSelectedDate(date);
            props.onDateSelect(date);
         }}
         customInput={customInput}
         //format="dd-MM-yyyy"
         dateFormat="MM-dd-yyyy"
         style={{borderColor: 'transparent', fontWeight: 'bold'}}
      />
   );
};

export default CustomDateTimePicker;
